export enum BackgroundChargeJobStatus {
  RUNNING = 'RUNNING',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
}

const AVAILABLE_STATUS = Object.keys(BackgroundChargeJobStatus);

class BackgroundChargeJob {
  public readonly status: BackgroundChargeJobStatus;
  public readonly errors: string;
  constructor({ status, errors }: { status: BackgroundChargeJobStatus; errors: string }) {
    this.status = status;
    this.errors = errors;
  }

  public static fromJSON = (value: any) => {
    const { status, errors } = Object.assign({}, value);

    if (status && !AVAILABLE_STATUS.includes(status.toUpperCase()))
      throw new TypeError('.status must be a valid action string');
    if (errors && typeof errors !== 'object') throw new TypeError('.errors must be a object');

    return new BackgroundChargeJob({
      status: status.toUpperCase(),
      errors: errors ? errors.map((e: any) => e.data).join(', ') : '',
    });
  };
}

export default BackgroundChargeJob;
